const Hero = () => {
  return (
    <>
      <div className='wp-block-group cf--color-image-text cf--color-image-text--links is-layout-flow wp-block-group-is-layout-flow'>
        <div className='wp-block-group__inner-container'>
          <figure className='wp-block-image size-full'>
            <img
              decoding='async'
              width='750'
              height='626'
              className='wp-image-4993 jetpack-lazy-image'
              src='https://i0.wp.com/www.theciderfarm.com/wp-content/uploads/2021/09/home-restaraunt@2x.jpg?resize=750%2C626&#038;ssl=1'
              alt
              data-recalc-dims='1'
              data-lazy-srcset='https://i0.wp.com/www.theciderfarm.com/wp-content/uploads/2021/09/home-restaraunt@2x.jpg?w=925&amp;ssl=1 925w, https://i0.wp.com/www.theciderfarm.com/wp-content/uploads/2021/09/home-restaraunt@2x.jpg?resize=300%2C250&amp;ssl=1 300w, https://i0.wp.com/www.theciderfarm.com/wp-content/uploads/2021/09/home-restaraunt@2x.jpg?resize=768%2C641&amp;ssl=1 768w, https://i0.wp.com/www.theciderfarm.com/wp-content/uploads/2021/09/home-restaraunt@2x.jpg?resize=600%2C501&amp;ssl=1 600w'
              data-lazy-sizes='(max-width: 750px) 100vw, 750px'
              data-lazy-src='https://i0.wp.com/www.theciderfarm.com/wp-content/uploads/2021/09/home-restaraunt@2x.jpg?resize=750%2C626&amp;is-pending-load=1#038;ssl=1'
              srcset='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
            />
            <noscript>
              <img
                data-lazy-fallback='1'
                decoding='async'
                loading='lazy'
                width='750'
                height='626'
                className='wp-image-4993'
                src='https://i0.wp.com/www.theciderfarm.com/wp-content/uploads/2021/09/home-restaraunt@2x.jpg?resize=750%2C626&#038;ssl=1'
                alt=''
                srcset='https://i0.wp.com/www.theciderfarm.com/wp-content/uploads/2021/09/home-restaraunt@2x.jpg?w=925&amp;ssl=1 925w, https://i0.wp.com/www.theciderfarm.com/wp-content/uploads/2021/09/home-restaraunt@2x.jpg?resize=300%2C250&amp;ssl=1 300w, https://i0.wp.com/www.theciderfarm.com/wp-content/uploads/2021/09/home-restaraunt@2x.jpg?resize=768%2C641&amp;ssl=1 768w, https://i0.wp.com/www.theciderfarm.com/wp-content/uploads/2021/09/home-restaraunt@2x.jpg?resize=600%2C501&amp;ssl=1 600w'
                sizes='(max-width: 750px) 100vw, 750px'
                data-recalc-dims='1'
              />
            </noscript>
          </figure>

          <div className='wp-block-group is-layout-flow wp-block-group-is-layout-flow'>
            <div className='wp-block-group__inner-container cf-hero'>
              <h2 className='wp-block-heading'>
                Welcome to The Cider Farm Tasting Room
              </h2>

              <p>
                Discover a unique tasting experience at The Cider Farm Tasting
                Room. Find a relaxing atmosphere where you can enjoy our
                selection of foundation and limited release ciders. Our organic
                orchard produces wine-like ciders and French-style apple brandy
                from our <em>wine grapes of apples</em>. Our Drinks Menu
                features specialty cocktails made with our Cider, Apple Brandy
                and Apple Brandy Maple Syrup. We offer small plates that are
                curated to pair perfectly with our ciders. The ingredients are
                sources from other local, often organic, suppliers - many of
                whom are our friends. See you at the tasting room!
              </p>

              <p>
                <a
                  href='https://theciderfarm.com/events/'
                  data-type='page'
                  data-id='2331'
                >
                  Events
                </a>
                <a
                  href='https://theciderfarm.com/menu/'
                  data-type='page'
                  data-id='4922'
                >
                  Menu
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
